import { render, staticRenderFns } from "./Plumber.vue?vue&type=template&id=3f8e8e23&scoped=true&"
import script from "./Plumber.vue?vue&type=script&lang=js&"
export * from "./Plumber.vue?vue&type=script&lang=js&"
import style0 from "./Plumber.vue?vue&type=style&index=0&id=3f8e8e23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8e8e23",
  null
  
)

export default component.exports